/**
 * 用于确定动画各个状态的显示区间
 */
import { makeBetweenNo } from '../../helpers/unit'
export const ANIMATE_AREA = {
	// 急速赛马
	'jssm':{
		countdown: _.concat(makeBetweenNo(0, 60), makeBetweenNo(110, 120)),
	    run: makeBetweenNo(65, 109),
	    winner: makeBetweenNo(61, 109),
	    error: makeBetweenNo(61, 70),
	    cycle: 120,
	    delay: 10
	},
	// 北京PK10
	'pk10':{
		countdown: _.concat(makeBetweenNo(0, 175), makeBetweenNo(270, 300)),
        run: makeBetweenNo(180, 269),
        winner: makeBetweenNo(176, 269),
        error: makeBetweenNo(176, 180),
	    cycle: 300,
	    delay: 30
	},
	// 众合PK10
	'zh10':{
		countdown: _.concat(makeBetweenNo(0, 60), makeBetweenNo(110, 120)),
	    run: makeBetweenNo(65, 109),
	    winner: makeBetweenNo(61, 109),
	    error: makeBetweenNo(61, 70),
	    cycle: 120,
	    delay: 10
	},
	// 意大利PK10
	'ydl10':{
		countdown: _.concat(makeBetweenNo(0, 40), makeBetweenNo(85, 90)),
	    run: makeBetweenNo(45, 84),
	    winner: makeBetweenNo(41, 84),
	    error: makeBetweenNo(41, 35),
	    cycle: 90,
	    delay: 5
	},
	// 幸运飞艇
	'xyft':{
		countdown: _.concat(makeBetweenNo(0, 175), makeBetweenNo(270, 300)),
		run: makeBetweenNo(180, 269),
		winner: makeBetweenNo(176, 269),
		error: makeBetweenNo(176, 180),
		cycle: 300,
		delay: 30
	},
}